import React, { useState, useEffect } from 'react';

import { ContentBox } from "../../ContentBox"
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { EnableBadge, AddButton, Space, DisableBadge } from '../../../Res/BaseButton';
import 'rc-datepicker/lib/style.css';
import moment from 'moment';
import { ManagementPrompt } from '../../../Res/ManagementPrompt';
import { setVal2Token, getval2Token } from '../../../../Login/Auth';

import { SELECT_VAL_TYPE_INT } from '../../../Res/BaseInput';
import { ReqLeagueList, get_league_type_string } from '../../../../../item/MyStat/ItemLeague';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { api_getLeagueList } from '../../../../../api/MyStat/apiLeague';
import { TableListTitle, setTD, setTDLink, ListBox } from '../../../../../item/ItemTableList';
import { ACTIVATION_ENABLE, search_activation_attr, get_activation_color, get_activation_string } from '../../../../../item/MyStat/ItemMyStatBase';

export function LeagueList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [searchItems, setSearchItems] = useState([])

    const [leagueList, setLeagueList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [enableCount, setEnableCount] = useState(0)
    const [disableCount, setDisableCount] = useState(0)

    // const [mReqLeagueList, setReqLeagueList] = useState({})

    const [list_obj, set_list_obj] = useState({})

    const [searchItem, set_searchItem] = useState()

    useEffect(() => {
        var searchItems = [
            [
                new SearchInput({
                    key: 'league_name',
                    val: '',
                    defaultVal: '',
                    title: '以中文名稱搜尋',
                    col: 4
                }),
                new SearchSelect({
                    key: 'league_activation',
                    val: ACTIVATION_ENABLE,
                    defaultVal: ACTIVATION_ENABLE,
                    valType: SELECT_VAL_TYPE_INT,
                    title: '狀態',
                    col: 4,
                    attr: search_activation_attr
                })
            ],
            // new SearchBrLine()
        ]
        setSearchItems(searchItems)
    }, [])

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqLeagueList = new ReqLeagueList({ start, limit })
            if (url === "") {
                toSearch({ searchItem: mReqLeagueList, page: url.page })
            } else {
                mReqLeagueList.fromJson(url)
                // console.log(mReqLeagueList)
                toSearch({ searchItem: mReqLeagueList, page: url.page })
            }
        }
    }, [id])

    useEffect(() => {
        var contents = []
        leagueList.forEach(item => {
            var content = []
            content.push(setTD({ content: item._id }))
            content.push(setTDLink({ link: 'League_Detail', content: item.league_name, key: 'leagueEdit', val: item }))
            content.push(setTD({ content: 0 }))
            content.push(setTD({ content: get_league_type_string(item.league_type) }))
            content.push(setTD({ content: moment(item.league_last_change).format('YYYY-MM-DD') }))
            content.push(setTD({ content: get_activation_string(item.league_activation), color: get_activation_color(item.league_activation) }))
            contents.push(content)
        })
        // console.log(contents)
        var lb = {
            titles: [
                new TableListTitle('編號', 1),
                new TableListTitle('中文名稱', 3),
                new TableListTitle('球隊總數', 1),
                new TableListTitle('賽事類型', 2),
                new TableListTitle('異動日期', 2),
                new TableListTitle('狀態', 2),
            ],
            contents
        }

        set_list_obj(lb)

    }, [leagueList])

    function toActionSearch(searchItems) {
        var mReqLeagueList = new ReqLeagueList({})
        searchItems.forEach((boxItem) => {
            if (Array.isArray(boxItem)) {
                boxItem.forEach(item => {
                    mReqLeagueList[item.key] = item.val
                })
            }
        })
        // console.log(mReqLeagueList)
        setSearchItems(searchItems)
        toSearch({ searchItem: mReqLeagueList })
    }

    function toSearch({ searchItem, page = 1 }) {
        console.log("toSearch")
        console.log(searchItem)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqLeagueList = new ReqLeagueList({ start, limit })
        if (searchItem !== undefined){
            mReqLeagueList.fromJson(searchItem)
            mReqLeagueList.start = start
            mReqLeagueList.limit = limit
        }
        // setReqLeagueList(mReqLeagueList)
        set_searchItem(mReqLeagueList)
        setVal2Token("url", mReqLeagueList, id)
        getLeagueList(mReqLeagueList)
    }

    function getLeagueList(mReqLeagueList) {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        //console.log("getCustomerContractList")
        //console.log(mReqCustomerContractList)
        // console.log(mReqLeagueList)
        api_getLeagueList({
            mReqLeagueList,
            success: (obj) => {
                console.log(obj)
                setLeagueList(obj.list)
                setCount(obj.count)
                setEnableCount(obj.enableCount)
                setDisableCount(obj.disableCount)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/League_Add");
    }

    var baseTitle = "聯盟列表"
    var baseContent =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"啟用"} count={enableCount} />
                    <DisableBadge text={"停用"} count={disableCount} />
                    <AddButton name={"新增"} action={toAdd} />
                </div>
            </div>
            <Space />
            <ListBox row={6} lb={list_obj} srl={setLeagueList} count={count} page={page} sp={toSearch} searchItem={searchItem} />
        </>
    return (
        <>
            <BaseSearchBox action={toActionSearch} items={searchItems} />
            <ContentBox title={baseTitle} content={baseContent} hasDrawer={true} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}

